import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';
import { Master, Subscriber  } from '@providers/index';

@Component({
  selector: 'page-select',
  templateUrl: 'page.html'
})
export class SelectPage {

  List: any = [];
  keyword='';
  project_id:0;
  data_user: any=[];

  select_mod:any;
  
  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public subsApi: Subscriber,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.project_id = this.navParams.get('project_id');
    this.select_mod = this.navParams.get('select_mod');
    this.data_user = JSON.parse(localStorage.data_user);
    console.log("user login =>",this.data_user);
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(keyword=''){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = {
      keyword,
      modul_id:4
    };
    if(keyword!=''){
      params.keyword=keyword;
    }

      this.subsApi.getEmployee(params).subscribe((resp:any) => {
        this.List = resp.data;
        console.log("data employee",resp.data)
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
    
  }

  select(item){
    if(this.select_mod == 1){
      let params = {
        notification_code : 'new_project_note',
        reference_id      : this.project_id,
        user_id           : item.user_id,
        created_by        : this.data_user.data.user_id,
      };
      
        this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
  
        this.closeModal();
        });
    }
    if(this.select_mod==2){
      let data = { item:item };
      this.viewCtrl.dismiss(data);
    }
    else{
      
    }

  }

  onInput(e){
    this.getList(this.keyword);
  }

  onCancel(e){
    this.getList();
  }

  closeModal(){
    let data = {item:''}
    this.viewCtrl.dismiss(data);
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/select/page.ts